import React from 'react';

import { useTranslation } from 'react-i18next';

import { useJournalEventsFiltersContext } from '@features/JournalEventsFilters/lib/useJournalEventsFiltersContext';
import { Icon, UiMultiSelect } from '@shared/ui';

import cls from './FilterByEstimate.module.css';

export const FilterByEstimate = () => {
    const { estimatesData, onEstimateClick, estimatesDefaultValues, onClearEstimatesValues } =
        useJournalEventsFiltersContext();
    const { t } = useTranslation();
    return (
        <UiMultiSelect
            options={estimatesData}
            defaultValues={estimatesDefaultValues}
            placeholder={t('JournalEvents.Filters.Filter.byEstimate.placeholder')}
            leftIconSlot={<Icon iconName="taskEstimate" fill="#CE66F1" />}
            arrowIconSlot={<Icon iconName="selectArrow" />}
            clearIconSlot={<Icon iconName="resetInput" />}
            onItemClickCb={onEstimateClick}
            onClearValuesCb={onClearEstimatesValues}
            needSearch
            optionsListClassNames={cls.optionsList}
        />
    );
};
